<script setup>
import { computed } from 'vue'
import Icon from '@/Components/UI/Icon.vue'

const props = defineProps({
  tone: { type: String, required: true }, // ok|warn|danger|info|muted
  variant: { type: String, default: 'soft' }, // soft|solid|outline
  icon: { type: String, default: '' },
  label: { type: String, required: true },
  strike: { type: Boolean, default: false },
})

const toneStyles = {
  ok:     { solid: 'bg-[color:var(--ok)] text-white',       soft: 'bg-[color:var(--okSoft)] text-[color:var(--ok)]',       outline: 'border border-[color:var(--ok)] text-[color:var(--ok)]' },
  warn:   { solid: 'bg-[color:var(--warn)] text-white',     soft: 'bg-[color:var(--warnSoft)] text-[color:var(--warn)]',   outline: 'border border-[color:var(--warn)] text-[color:var(--warn)]' },
  danger: { solid: 'bg-[color:var(--danger)] text-white',   soft: 'bg-[color:var(--dangerSoft)] text-[color:var(--danger)]', outline: 'border border-[color:var(--danger)] text-[color:var(--danger)]' },
  info:   { solid: 'bg-[color:var(--info)] text-white',     soft: 'bg-[color:var(--infoSoft)] text-[color:var(--info)]',   outline: 'border border-[color:var(--info)] text-[color:var(--info)]' },
  muted:  { solid: 'bg-[color:var(--muted)] text-white',    soft: 'bg-[color:var(--surfaceAlt)] text-[color:var(--inkSoft)]', outline: 'border border-[color:var(--line)] text-[color:var(--inkSoft)]' },
}

const classes = computed(() => toneStyles[props.tone][props.variant])
</script>

<template>
  <span
    class="inline-flex items-center gap-1 px-2 h-5 rounded-[var(--radius-full)] text-xs font-medium whitespace-nowrap"
    :class="classes"
  >
    <Icon v-if="icon" :name="icon" :size="12" />
    <span :class="strike && 'line-through'">{{ label }}</span>
  </span>
</template>
